import React from "react"
import { Link } from "gatsby"
import Title from "../Global/Title"

const Info = () => {
  return (
    <section className='py-5'>
      <div className="container">
        <Title title='our story'>

        </Title>
        <div className="row">
          <div className="col-10 col-sm-8 mx-auto text-center">
            <p className="lead text-muted mb-5">
              An example site to illustrate an small e-commerce solution.  Payments will not be processed and products do not exist.
            </p>
            <Link to='/about'>
              <button className='btn text-uppercase btn-orange'>
                About Page
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Info
